import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import { imgBaseUrl } from "../../../api/api";
import TestLayout from "./TestLayout";

const MarksheetSample = () => {
  const [type, setType] = useState("1");
  const [settings, setSettings] = useState("");
  useEffect(() => {
    setSettings(JSON.parse(localStorage.getItem("setting") ?? "{}"));
  }, []);
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <TestLayout />
                  <div className="col-12">
                    <div className="d-flex gap-2 shadow-sm bg-white align-items-center p-3">
                      <button
                        onClick={(e) => setType("1")}
                        className={`btn btn-sm ${
                          type == 1 ? "btn-primary" : "btn-outline-primary"
                        } `}
                      >
                        1
                      </button>
                      <button
                        onClick={(e) => setType("2")}
                        className={`btn btn-sm ${
                          type == 2 ? "btn-primary" : "btn-outline-primary"
                        } `}
                      >
                        2
                      </button>
                      <button
                        onClick={(e) => setType("3")}
                        className={`btn btn-sm ${
                          type == 3 ? "btn-primary" : "btn-outline-primary"
                        } `}
                      >
                        3
                      </button>
                      <button
                        onClick={(e) => setType("4")}
                        className={`btn btn-sm ${
                          type == 4 ? "btn-primary" : "btn-outline-primary"
                        } `}
                      >
                        4
                      </button>
                      <Link
                        to={`/student/marksheet`}
                        className="btn btn-sm btn-outline-primary"
                      >
                        Back
                      </Link>
                    </div>
                    {type == "1" && (
                      <>
                        <div className="container my-3">
                          <div
                            className="border card border-dark"
                            style={{
                              width: "210mm",
                              minHeight: "297mm",
                              margin: "auto",
                              padding: "15mm",
                              boxSizing: "border-box",
                            }}
                          >
                            {/* Header */}
                            <header className="d-flex p-3 bg-label-primary rounded justify-content-between align-items-center border-bottom border-dark pb-2 mb-3">
                              {/* Left Logo */}
                              <div>
                                <img
                                  src={imgBaseUrl + settings?.logo_img}
                                  alt="School Logo"
                                  style={{ height: "80px", width: "auto" }}
                                />
                              </div>

                              {/* Center Details */}
                              <div className="text-center flex-grow-1">
                                <h1 className="m-0">{settings?.name}</h1>
                                <p className="m-0">
                                  {settings?.village} {settings?.district}{" "}
                                  {settings?.state} {settings?.pin_code}
                                </p>
                                <p className="m-0">
                                  📞 {settings?.mobile}{" "}
                                  {settings?.secondary_mobile}
                                </p>
                                <p className="m-0">✉️ {settings?.email}</p>
                              </div>

                              {/* Right Logo */}
                              <div className="text-end">
                                <img
                                  src={imgBaseUrl + settings?.logo_img}
                                  alt="School Logo"
                                  style={{ height: "80px", width: "auto" }}
                                />
                              </div>
                            </header>
                            <div className="d-flex justify-content-center">
                              <span className="m-0 fw-bold text-white py-2 px-2 bg-primary rounded">
                                Report Card (2023-2024)
                              </span>
                            </div>

                            {/* Student Info */}
                            <table className="table table-borderless  text-center">
                              <tbody>
                                <tr>
                                  <th>Student's Name</th>
                                  <td>LAVYA TANWARD</td>
                                  <th>Father's Name</th>
                                  <td>RAKESH KUMAR TANWARD</td>
                                </tr>
                                <tr>
                                  <th>Mother's Name</th>
                                  <td>REENU DEVI</td>
                                  <th>DOB</th>
                                  <td>27 Jan 2015</td>
                                </tr>
                                <tr>
                                  <th>Class</th>
                                  <td>II</td>
                                  <th>Section</th>
                                  <td>II</td>
                                </tr>
                                <tr>
                                  <th>S.R. No.</th>
                                  <td>3172</td>
                                  <th>Roll No.</th>
                                  <td>2028</td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Marks Table */}
                            <table className="table table-bordered text-center">
                              <thead>
                                <tr>
                                  <th className="bg-label-primary" rowSpan="2">
                                    Subject
                                  </th>
                                  <th className="bg-label-primary" colSpan="2">
                                    Half Yearly
                                  </th>
                                  <th className="bg-label-primary" colSpan="2">
                                    Annual Exam
                                  </th>
                                  <th className="bg-label-primary" colSpan="2">
                                    Total (200)
                                  </th>
                                </tr>
                                <tr>
                                  <th className="bg-label-primary">Marks</th>
                                  <th className="bg-label-primary">Grade</th>
                                  <th className="bg-label-primary">Marks</th>
                                  <th className="bg-label-primary">Grade</th>
                                  <th className="bg-label-primary">Total</th>
                                  <th className="bg-label-primary">Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Hindi</td>
                                  <td>94</td>
                                  <td>A1</td>
                                  <td>86</td>
                                  <td>A2</td>
                                  <td>180</td>
                                  <td>A2</td>
                                </tr>
                                <tr>
                                  <td>English</td>
                                  <td>98</td>
                                  <td>A1</td>
                                  <td>91</td>
                                  <td>A1</td>
                                  <td>189</td>
                                  <td>A1</td>
                                </tr>
                                <tr>
                                  <td>Maths</td>
                                  <td>96</td>
                                  <td>A1</td>
                                  <td>92</td>
                                  <td>A1</td>
                                  <td>188</td>
                                  <td>A1</td>
                                </tr>
                                <tr>
                                  <td>E.V.S</td>
                                  <td>86</td>
                                  <td>A2</td>
                                  <td>78</td>
                                  <td>B1</td>
                                  <td>164</td>
                                  <td>B1</td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>Grand Total</b>
                                  </td>
                                  <td colSpan="2">374 (A1)</td>
                                  <td colSpan="2">347 (A1)</td>
                                  <td colSpan="2">721 / 800 (A2)</td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Summary */}
                            <table className="table table-bordered text-center">
                              <thead className="table-light">
                                <tr>
                                  <th className="bg-label-primary">
                                    Percentage
                                  </th>
                                  <th className="bg-label-primary">Division</th>
                                  <th className="bg-label-primary">
                                    Attendance
                                  </th>
                                  <th className="bg-label-primary">
                                    Discipline
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>90.13%</td>
                                  <td>I</td>
                                  <td>175</td>
                                  <td>A</td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Co-Scholastic */}
                            <table className="table table-bordered text-center">
                              <thead className="table-light">
                                <tr>
                                  <th colSpan="2" className="bg-label-primary">
                                    Co-Scholastic Area
                                  </th>
                                  <th className="bg-label-primary">Term-1</th>
                                  <th className="bg-label-primary">Term-2</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colSpan="2">Work Education</td>
                                  <td>B</td>
                                  <td>B</td>
                                </tr>
                                <tr>
                                  <td colSpan="2">Art & Drawing</td>
                                  <td>A</td>
                                  <td>B</td>
                                </tr>
                                <tr>
                                  <td colSpan="2">Health & Physical Ed.</td>
                                  <td>A</td>
                                  <td>B</td>
                                </tr>
                                <tr>
                                  <td colSpan="2">Music & Dance</td>
                                  <td>A</td>
                                  <td>B</td>
                                </tr>
                                <tr>
                                  <td colSpan="2">G.K.</td>
                                  <td>A</td>
                                  <td>B</td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Remarks */}
                            <div className="my-3">
                              <p>
                                <b>Teacher’s Remarks:</b> is an enthusiastic
                                learner
                              </p>
                              <p>
                                <b>Promoted to Class:</b> III
                              </p>
                              <p>
                                <b>Date:</b> 01 April 2025
                              </p>
                            </div>

                            {/* Signatures */}
                            <div className="d-flex justify-content-between mt-4 fw-bold">
                              <div>Sign. of Class Teacher: __________</div>
                              <div>Sign. of Principal: __________</div>
                            </div>

                            {/* Grading Scale */}
                            <h3 className="text-center mt-4">Grading Scale</h3>
                            <table className="table table-bordered text-center">
                              <thead className="table-light">
                                <tr>
                                  <th className="bg-label-primary">Marks</th>
                                  <th className="bg-label-primary">Grade</th>
                                  <th className="bg-label-primary">Marks</th>
                                  <th className="bg-label-primary">Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>91-100</td>
                                  <td>A1</td>
                                  <td>61-70</td>
                                  <td>C1</td>
                                </tr>
                                <tr>
                                  <td>86-90</td>
                                  <td>A2</td>
                                  <td>51-60</td>
                                  <td>C2</td>
                                </tr>
                                <tr>
                                  <td>76-85</td>
                                  <td>B1</td>
                                  <td>31-50</td>
                                  <td>D</td>
                                </tr>
                                <tr>
                                  <td>71-75</td>
                                  <td>B2</td>
                                  <td>30 & Below</td>
                                  <td>E</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                    {type == "2" && (
                      <>
                        <div className="container my-4">
                          <div className="row justify-content-center">
                            <div className="a4-sheet col-12 col-md-10 col-lg-8 border bg-white p-4">
                              {/* Header */}
                              <div className="school-header text-center mb-3">
                                <div className="d-flex justify-content-between small">
                                  <div>Affiliation No.: 1121775</div>
                                  <div>Reg No.: 450/JAIPUR/2001-2002</div>
                                </div>

                                <div className="main-header bg-primary-subtle rounded-4 p-2 mt-2">
                                  <h1 className="m-0 text-danger fw-bold">
                                    {settings?.name}
                                  </h1>
                                  <p className="m-0">
                                    {settings?.village} {settings?.district}{" "}
                                    {settings?.state} {settings?.pin_code}
                                  </p>
                                  <p className="m-0">
                                    📞 {settings?.mobile}{" "}
                                    {settings?.secondary_mobile}
                                  </p>
                                  <p className="m-0">✉️ {settings?.email}</p>
                                </div>
                              </div>

                              {/* Title */}
                              <div className="title text-center mb-3">
                                <h5 className="text-white fw-bold border border-dark bg-success rounded px-3 py-1 d-inline-block">
                                  Report Card
                                </h5>
                                <p className="fw-bold border rounded border-dark d-inline-block px-3 py-1 ms-2">
                                  Academic Session: 2024-2025
                                </p>
                              </div>

                              {/* Student Info */}
                              <table className="table table-sm mb-3">
                                <tbody>
                                  <tr>
                                    <td>
                                      <strong>Student’s Name</strong> :
                                      SUDHANSHU JHAJHARA
                                    </td>
                                    <td>
                                      <strong>Father’s Name</strong> : SANWAR
                                      MAL JHAJHARA
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Mother’s Name</strong> : MOHANI
                                      DEVI
                                    </td>
                                    <td>
                                      <strong>Date of Birth</strong> : 03 June
                                      2014
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Class</strong> : VII
                                    </td>
                                    <td>
                                      <strong>Section</strong> : A
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>S.R. No.</strong> : 3382
                                    </td>
                                    <td>
                                      <strong>Roll No.</strong> : 7042
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>APAAR ID</strong> : —
                                    </td>
                                    <td>
                                      <strong>NIC ID</strong> : 542864426
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Marks Table */}
                              <table className="table table-bordered text-center align-middle mb-3">
                                <thead className="table-primary">
                                  <tr>
                                    <th rowSpan="2">Subject</th>
                                    <th colSpan="3">Pd. Test (10)</th>
                                    <th rowSpan="2">Pd. Test (Total) 30</th>
                                    <th rowSpan="2">Half Yearly 70</th>
                                    <th rowSpan="2">Total 100</th>
                                    <th rowSpan="2">Annual Exam 100</th>
                                    <th colSpan="2">Subject Total 200</th>
                                  </tr>
                                  <tr>
                                    <th>(I)</th>
                                    <th>(II)</th>
                                    <th>(III)</th>
                                    <th>Total</th>
                                    <th>Grade</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>HINDI</td>
                                    <td>10</td>
                                    <td>9</td>
                                    <td>7</td>
                                    <td>26</td>
                                    <td>46</td>
                                    <td>72</td>
                                    <td>65</td>
                                    <td>137</td>
                                    <td>C1</td>
                                  </tr>
                                  <tr className="fw-bold text-danger">
                                    <td>Grand Total</td>
                                    <td>57</td>
                                    <td>48</td>
                                    <td>48</td>
                                    <td>153</td>
                                    <td>241</td>
                                    <td>394</td>
                                    <td>385</td>
                                    <td>779</td>
                                    <td>C1</td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Result Summary */}
                              <table className="table table-bordered text-center mb-3">
                                <thead className="table-light fw-bold">
                                  <tr>
                                    <td>Grand Total</td>
                                    <td>Division</td>
                                    <td>Percentage %</td>
                                    <td>Rank in Class</td>
                                    <td>Attendance</td>
                                    <td>Discipline</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr className="text-danger">
                                    <td>779 / 1200</td>
                                    <td>I</td>
                                    <td>64.92%</td>
                                    <td>—</td>
                                    <td>180</td>
                                    <td>A</td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Co-Scholastic */}
                              <table className="table table-bordered text-center mb-3">
                                <thead className="table-primary">
                                  <tr>
                                    <th>Co-Scholastic Area</th>
                                    <th>Term-1</th>
                                    <th>Term-2</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>Work Education</td>
                                    <td>C</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td>Art Education & Drawing</td>
                                    <td>B</td>
                                    <td>A</td>
                                  </tr>
                                  <tr>
                                    <td>Health & Physical Education</td>
                                    <td>A</td>
                                    <td>A</td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Final Result */}
                              <div className="mb-3">
                                <p>
                                  <strong>Final Result :</strong>{" "}
                                  <input type="checkbox" defaultChecked />{" "}
                                  Passed <input type="checkbox" /> Passed With
                                  Grace <input type="checkbox" /> Supp.{" "}
                                  <input type="checkbox" /> Failed
                                </p>
                                <p>
                                  <strong>Class Teacher’s Remarks :</strong>{" "}
                                  needs better time <br />
                                  <strong>Date:</strong> 01 April 2025
                                </p>
                                <p>
                                  <strong>Promoted to class :</strong> VIII
                                </p>
                              </div>

                              {/* Signatures */}
                              <div className="d-flex justify-content-between mt-5">
                                <div
                                  className="text-center border-top border-dark pt-1"
                                  style={{ width: "200px" }}
                                >
                                  Sign. of Class Teacher
                                </div>
                                <div
                                  className="text-center border-top border-dark pt-1"
                                  style={{ width: "200px" }}
                                >
                                  Sign. of Principal
                                </div>
                              </div>

                              {/* Instructions */}
                              <div className="mt-4">
                                <h6 className="text-center">Instructions</h6>
                                <p className="text-center small mb-1">
                                  Grading scale for scholastic areas : Grades
                                  are awarded on a 8-Point grading scale
                                </p>
                                <table className="table table-bordered text-center">
                                  <thead className="table-primary">
                                    <tr>
                                      <th>Marks Range</th>
                                      <th>Grade</th>
                                      <th>Marks Range</th>
                                      <th>Grade</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>91-100</td>
                                      <td>A1</td>
                                      <td>61-70</td>
                                      <td>C1</td>
                                    </tr>
                                    <tr>
                                      <td>86-90</td>
                                      <td>A2</td>
                                      <td>51-60</td>
                                      <td>C2</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {type == "3" && (
                      <>
                        <div className="container-fluid d-flex justify-content-center my-4">
                          <div
                            className="card p-4 border border-3 border-dark"
                            style={{ width: "210mm", minHeight: "297mm" }}
                          >
                            <div className="a4-sheet">
                              {/* School Header */}
                              <div className="text-center border-bottom mb-2 pb-2">
                                <h1 className="m-0">{settings?.name}</h1>
                                <p className="m-0">
                                  {settings?.village} {settings?.district}{" "}
                                  {settings?.state} {settings?.pin_code}
                                </p>
                              </div>

                              {/* Session */}
                              <div className="text-center my-2">
                                <span className="badge bg-danger fs-6">
                                  ACADEMIC SESSION : 2024 - 2025
                                </span>
                              </div>

                              {/* Student Info */}
                              <table className="table table-sm table-borderless mb-3">
                                <tbody>
                                  <tr>
                                    <td>
                                      <strong>Student's Name :</strong> Rohan
                                      Sharma
                                    </td>
                                    <td>
                                      <strong>Class :</strong> VIII
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Father's Name :</strong> Mr. Anil
                                      Sharma
                                    </td>
                                    <td>
                                      <strong>Roll No. :</strong> 23
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Mother's Name :</strong> Mrs.
                                      Sunita Sharma
                                    </td>
                                    <td>
                                      <strong>Date of Birth :</strong>{" "}
                                      15-08-2012
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Marks Table */}
                              <table
                                className="table table-bordered text-center table-sm"
                                style={{ fontSize: "9px", lineHeight: "1.2" }}
                              >
                                <thead>
                                  <tr className="table-secondary">
                                    <th rowSpan="2" style={{ padding: "2px" }}>
                                      Subject Name
                                    </th>
                                    <th colSpan="3" style={{ padding: "2px" }}>
                                      Terms - 1 (40 Marks)
                                    </th>
                                    <th colSpan="3" style={{ padding: "2px" }}>
                                      Terms - 2 (60 Marks)
                                    </th>
                                    <th colSpan="3" style={{ padding: "2px" }}>
                                      Over All
                                      <br />
                                      T-1 (40)+T-2 (60)
                                    </th>
                                  </tr>
                                  <tr className="table-secondary">
                                    <th style={{ padding: "2px" }}>
                                      CA
                                      <br />
                                      10
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      Exam
                                      <br />
                                      30
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      Total
                                      <br />
                                      40
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      CA
                                      <br />
                                      10
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      Exam
                                      <br />
                                      50
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      Total
                                      <br />
                                      60
                                    </th>
                                    <th style={{ padding: "2px" }}>
                                      Grand Total
                                      <br />
                                      100
                                    </th>
                                    <th style={{ padding: "2px" }}>%</th>
                                    <th style={{ padding: "2px" }}>Grade</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ padding: "2px" }}>Hindi</td>
                                    <td>8</td>
                                    <td>24</td>
                                    <td>32</td>
                                    <td>9</td>
                                    <td>41</td>
                                    <td>50</td>
                                    <td>82</td>
                                    <td>82%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>
                                      Mathematics
                                    </td>
                                    <td>7</td>
                                    <td>26</td>
                                    <td>33</td>
                                    <td>8</td>
                                    <td>43</td>
                                    <td>51</td>
                                    <td>84</td>
                                    <td>84%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>
                                      Social-Study
                                    </td>
                                    <td>6</td>
                                    <td>22</td>
                                    <td>28</td>
                                    <td>7</td>
                                    <td>38</td>
                                    <td>45</td>
                                    <td>73</td>
                                    <td>73%</td>
                                    <td>C</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>Science</td>
                                    <td>8</td>
                                    <td>25</td>
                                    <td>33</td>
                                    <td>9</td>
                                    <td>42</td>
                                    <td>51</td>
                                    <td>84</td>
                                    <td>84%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>English</td>
                                    <td>7</td>
                                    <td>23</td>
                                    <td>30</td>
                                    <td>8</td>
                                    <td>40</td>
                                    <td>48</td>
                                    <td>78</td>
                                    <td>78%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>Sanskrit</td>
                                    <td>9</td>
                                    <td>26</td>
                                    <td>35</td>
                                    <td>9</td>
                                    <td>44</td>
                                    <td>53</td>
                                    <td>88</td>
                                    <td>88%</td>
                                    <td>A</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>
                                      H. Science/Ag. Science
                                    </td>
                                    <td>7</td>
                                    <td>24</td>
                                    <td>31</td>
                                    <td>8</td>
                                    <td>39</td>
                                    <td>47</td>
                                    <td>78</td>
                                    <td>78%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>Drawing</td>
                                    <td>9</td>
                                    <td>28</td>
                                    <td>37</td>
                                    <td>9</td>
                                    <td>46</td>
                                    <td>55</td>
                                    <td>92</td>
                                    <td>92%</td>
                                    <td>A</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>
                                      En. Science
                                    </td>
                                    <td>8</td>
                                    <td>27</td>
                                    <td>35</td>
                                    <td>9</td>
                                    <td>41</td>
                                    <td>50</td>
                                    <td>85</td>
                                    <td>85%</td>
                                    <td>B</td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "2px" }}>
                                      Physical Education
                                    </td>
                                    <td>9</td>
                                    <td>29</td>
                                    <td>38</td>
                                    <td>10</td>
                                    <td>48</td>
                                    <td>58</td>
                                    <td>96</td>
                                    <td>96%</td>
                                    <td>A</td>
                                  </tr>
                                  <tr className="fw-bold">
                                    <td style={{ padding: "2px" }}>
                                      Over All Grand Total
                                    </td>
                                    <td
                                      colSpan="9"
                                      className="text-start"
                                      style={{ padding: "2px" }}
                                    >
                                      ⇒ <strong>840 / 1000</strong> |{" "}
                                      <strong>84%</strong> |{" "}
                                      <strong>Division: I</strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              {/* Remarks */}
                              <div className="mt-2 small">
                                <p>
                                  <strong>Class Teacher's Remarks :</strong>{" "}
                                  Hardworking student, shows good progress.
                                </p>
                                <p>
                                  <strong>Promoted to Class :</strong> IX
                                  &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                                  <strong>Place :</strong> Barabanki
                                </p>
                                <p>
                                  <strong>Date :</strong> 25-03-2025
                                </p>
                              </div>

                              {/* Signatures */}
                              <div className="d-flex justify-content-between mt-4">
                                <div
                                  className="text-center border-top pt-1"
                                  style={{ width: "200px", fontSize: "13px" }}
                                >
                                  Signature of Class Teacher
                                </div>
                                <div
                                  className="text-center border-top pt-1"
                                  style={{ width: "200px", fontSize: "13px" }}
                                >
                                  Signature of Principal
                                </div>
                              </div>

                              {/* Instructions */}
                              <div className="mt-3">
                                <div className="text-center mb-2">
                                  <strong className="bg-warning px-2">
                                    INSTRUCTION
                                  </strong>
                                </div>
                                <p className="text-center small">
                                  Grading Scale for Scholastic Area : Grades are
                                  awarded on a 5 part grading scale as follows
                                </p>
                                <table className="table table-bordered text-center">
                                  <thead className="table-secondary">
                                    <tr>
                                      <th>Mark Range</th>
                                      <th>Grade</th>
                                      <th>Mark Range</th>
                                      <th>Grade</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>90 - 100</td>
                                      <td>A</td>
                                      <td>Below 40</td>
                                      <td>E</td>
                                    </tr>
                                    <tr>
                                      <td>76 - 89</td>
                                      <td>B</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>56 - 75</td>
                                      <td>C</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>41 - 55</td>
                                      <td>D</td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {type == "4" && (
                      <>
                        <div className="container my-4">
                          <div className="row justify-content-center">
                            <div
                              className="card p-3 marksheet position-relative bg-white"
                              style={{ maxWidth: "850px" }} // A4 sheet width fix
                            >
                              {/* Header Section */}
                              <div className="header-section p-4 mb-4">
                                <div className="row align-items-center">
                                  <div className="col-2">
                                    <div className="school-logo fs-1">🎓</div>
                                  </div>
                                  <div className="col-8 text-center">
                                    <h1 className="m-0">{settings?.name}</h1>
                                    <p className="m-0">
                                      {settings?.village} {settings?.district}{" "}
                                      {settings?.state} {settings?.pin_code}
                                    </p>
                                  </div>
                                  <div className="col-2 text-end">
                                    <div className="grade-box">
                                      <div className="h4 mb-0">A+</div>
                                      <small>Grade</small>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Student Information */}
                              <div className="row mb-4">
                                <div className="col-8">
                                  <div className=" border-0  bg-light">
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-6">
                                          <p className="mb-2">
                                            <strong>Student Name:</strong> RAHUL
                                            SHARMA
                                          </p>
                                          <p className="mb-2">
                                            <strong>Father's Name:</strong> MR.
                                            RAJESH SHARMA
                                          </p>
                                          <p className="mb-2">
                                            <strong>Mother's Name:</strong> MRS.
                                            PRIYA SHARMA
                                          </p>
                                        </div>
                                        <div className="col-6">
                                          <p className="mb-2">
                                            <strong>Roll Number:</strong>{" "}
                                            2024001
                                          </p>
                                          <p className="mb-2">
                                            <strong>Class:</strong> X-A
                                          </p>
                                          <p className="mb-2">
                                            <strong>Academic Year:</strong>{" "}
                                            2023-24
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div
                                    className="border border-2 border-secondary p-3 text-center"
                                    style={{ height: "120px" }}
                                  >
                                    <div className="text-muted mt-4">
                                      📷
                                      <br />
                                      <small>Student Photo</small>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Marks Table */}
                              <div className="table-responsive mb-4">
                                <table className="table table-bordered marks-table">
                                  <thead>
                                    <tr>
                                      <th
                                        rowSpan="2"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        Subject
                                      </th>
                                      <th colSpan="2">Theory</th>
                                      <th colSpan="2">Practical</th>
                                      <th
                                        rowSpan="2"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        Total (100)
                                      </th>
                                      <th
                                        rowSpan="2"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        Grade
                                      </th>
                                    </tr>
                                    <tr>
                                      <th>Max</th>
                                      <th>Obtained</th>
                                      <th>Max</th>
                                      <th>Obtained</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-start">
                                        <strong>English</strong>
                                      </td>
                                      <td>80</td>
                                      <td>72</td>
                                      <td>20</td>
                                      <td>18</td>
                                      <td>
                                        <strong>90</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">
                                        <strong>Mathematics</strong>
                                      </td>
                                      <td>80</td>
                                      <td>75</td>
                                      <td>20</td>
                                      <td>17</td>
                                      <td>
                                        <strong>92</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">
                                        <strong>Science</strong>
                                      </td>
                                      <td>80</td>
                                      <td>68</td>
                                      <td>20</td>
                                      <td>19</td>
                                      <td>
                                        <strong>87</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">
                                        <strong>Social Studies</strong>
                                      </td>
                                      <td>80</td>
                                      <td>70</td>
                                      <td>20</td>
                                      <td>16</td>
                                      <td>
                                        <strong>86</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">
                                        <strong>Hindi</strong>
                                      </td>
                                      <td>80</td>
                                      <td>65</td>
                                      <td>20</td>
                                      <td>18</td>
                                      <td>
                                        <strong>83</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start">
                                        <strong>Computer Science</strong>
                                      </td>
                                      <td>80</td>
                                      <td>78</td>
                                      <td>20</td>
                                      <td>19</td>
                                      <td>
                                        <strong>97</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                    <tr className="total-row">
                                      <td className="text-start">
                                        <strong>TOTAL</strong>
                                      </td>
                                      <td>
                                        <strong>480</strong>
                                      </td>
                                      <td>
                                        <strong>428</strong>
                                      </td>
                                      <td>
                                        <strong>120</strong>
                                      </td>
                                      <td>
                                        <strong>107</strong>
                                      </td>
                                      <td>
                                        <strong>535</strong>
                                      </td>
                                      <td>
                                        <span className="badge bg-success fs-6">
                                          A+
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              {/* Result Summary */}
                              <div className="row mb-4">
                                <div className="col-6">
                                  <div className="card border-primary">
                                    <div className="card-header bg-primary text-white text-center">
                                      <h5 className="mb-0">Result Summary</h5>
                                    </div>
                                    <div className="card-body">
                                      <p className="mb-2">
                                        <strong>Total Marks:</strong> 600
                                      </p>
                                      <p className="mb-2">
                                        <strong>Marks Obtained:</strong> 535
                                      </p>
                                      <p className="mb-2">
                                        <strong>Percentage:</strong> 89.17%
                                      </p>
                                      <p className="mb-0">
                                        <strong>Result:</strong>{" "}
                                        <span className="text-success fw-bold">
                                          PASS
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="card border-info">
                                    <div className="card-header bg-info text-white text-center">
                                      <h5 className="mb-0">Grading Scale</h5>
                                    </div>
                                    <div className="card-body small">
                                      <p className="mb-1">
                                        <strong>A+:</strong> 90-100%
                                        (Outstanding)
                                      </p>
                                      <p className="mb-1">
                                        <strong>A:</strong> 80-89% (Excellent)
                                      </p>
                                      <p className="mb-1">
                                        <strong>B+:</strong> 70-79% (Very Good)
                                      </p>
                                      <p className="mb-1">
                                        <strong>B:</strong> 60-69% (Good)
                                      </p>
                                      <p className="mb-0">
                                        <strong>C:</strong> 50-59% (Average)
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Signature Section */}
                              <div className="signature-section pt-4">
                                <div className="row">
                                  <div className="col-4 text-center">
                                    <div className="border-top border-dark pt-2 mt-5">
                                      <strong>Class Teacher</strong>
                                      <br />
                                      <small>Mrs. Anjali Gupta</small>
                                    </div>
                                  </div>
                                  <div className="col-4 text-center">
                                    <div className="border-top border-dark pt-2 mt-5">
                                      <strong>Principal</strong>
                                      <br />
                                      <small>Dr. Suresh Kumar</small>
                                    </div>
                                  </div>
                                  <div className="col-4 text-center">
                                    <div className="border-top border-dark pt-2 mt-5">
                                      <strong>Date of Issue</strong>
                                      <br />
                                      <small>March 15, 2024</small>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Footer */}
                              <div className="text-center mt-4 pt-3 border-top">
                                <small className="text-muted">
                                  This is a computer generated marksheet and
                                  does not require signature
                                </small>
                              </div>
                            </div>
                          </div>

                          {/* Print Button */}
                          <div className="text-center mt-4 no-print">
                            <button
                              className="btn btn-primary btn-lg"
                              onClick={() => window.print()}
                            >
                              🖨️ Print Marksheet
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarksheetSample;
